export type FeedbackType = 'bug' | 'feature' | 'general';
export type FeedbackStatus = 'new' | 'in_review' | 'planned' | 'resolved' | 'wont_fix';

export interface FeedbackItemBase {
  id: number;
  type: FeedbackType;
  title: string;
  description: string;
  status: FeedbackStatus;
  rating: number | null;
  admin_notes: string | null;
  created_at: string;
}

export interface FeedbackItemAdmin extends FeedbackItemBase {
  submitted_by: string;
  page_url: string | null;
  browser_info: string | null;
  updated_at: string;
}

export const FEEDBACK_STATUS_LABELS: Record<FeedbackStatus, string> = {
  new: 'New',
  in_review: 'In Review',
  planned: 'Planned',
  resolved: 'Resolved',
  wont_fix: "Won't Fix",
};

export interface SubmitFeedbackPayload {
  type: FeedbackType;
  title: string;
  description: string;
  page_url?: string;
  browser_info?: string;
  rating?: number;
}

export interface UpdateFeedbackPayload {
  status?: FeedbackStatus;
  admin_notes?: string;
}

export interface FeedbackListResponse {
  success: boolean;
  feedback: FeedbackItemAdmin[];
  pagination: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

export interface FeedbackStatsResponse {
  success: boolean;
  data: {
    newCount: number;
  };
}

export interface FeedbackDetailResponse {
  success: boolean;
  data: FeedbackItemAdmin;
}

export interface FeedbackSubmitResponse {
  success: boolean;
  data: FeedbackItemAdmin;
}
